import loadScripts from '../utils/loadScripts';
import serverMap from '../../../config/serverMap';
import $x from '../$x';

var dd;
export default {
    isDingtalk: true,
    ready() {
        return new Promise(resolve => {
            loadScripts(serverMap.domain + 'Scripts/dingtalk.open.min.js?_cv=' + $x.userInfo.cacheVer, function () {
                dd = self.dd
                resolve()
            })
        })
    },
    //option: {hidden, onSuccess, onFail}
    hideTitle(option) {
        var opt = Object.assign({
            hidden: true,
            onSuccess: $x.noop,
            onFail: $x.noop
        }, option)
        dd.biz.navigation.hideBar(opt)
    },
    closeWin() {
        dd.biz.navigation.close({
            onSuccess: $x.noop,
            onFail: $x.noop
        })
    }
}
